import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';


export default function HelpCenterLink({ helpCenterUrl, linkText }) {
  if (!helpCenterUrl) return null;

  return (
    <a
      className="mt-4 mb-4 d-inline-block"
      href={helpCenterUrl}
      name="help-center-link"
      rel="noopener noreferrer"
      target="_blank"
    >
      <FontAwesomeIcon className="right-buffer-sm" icon={faQuestionCircle}/>
      {linkText}
    </a>
  );
}

HelpCenterLink.propTypes = {
  helpCenterUrl: PropTypes.string,
  linkText: PropTypes.string.isRequired
};
